import React, { useRef, useEffect, useState } from "react";
import Header from "../component/Header";
import CommonBanner from "../component/CommonBanner";
import Footer from "../component/Footer";
import { Container,Table } from "react-bootstrap";
import HomeImg from "../assets/images/home-img.png";
function CompareHomes() {
  const tableRef = useRef(null);
  const [totalColumns, setTotalColumns] = useState('');
  useEffect(() => {
    if (tableRef.current) {
      const headerRow = tableRef.current.querySelector("thead tr");
      const columnCount = headerRow ? headerRow.children.length : '';
      setTotalColumns(columnCount);
    }
  }, []);
  return (
    <>
      <div className="main compare-homes-page">
        <Header />
        <CommonBanner title="Compare Homes" />
        <section className="compare-homes-section common-padding">
          <Container>
            <ul>
              <li>
                <a href="#Overview" title="Overview" className="active">
                  Overview
                </a>
              </li>
              <li>
                <a href="#Interior" title="Interior">
                  Interior
                </a>
              </li>
              <li>
                <a href="#Property" title="Property">
                  Property
                </a>
              </li>
              <li>
                <a href="#HOAFinancial" title="HOA Financial">
                  HOA Financial
                </a>
              </li>
              <li>
                <a href="#Neighbourhood" title="Community and neighbourhood">
                  Community and neighbourhood
                </a>
              </li>
            </ul>
            <div className="compare-homes-view">
              <Table className="sticky-table" ref={tableRef}>
                <thead>
                  <tr>
                    <th> </th>
                    <th className="home-box"> 
                      <div>
                        <img src={HomeImg} alt="Home" />
                        <p>529 Clinton Avenue, Rockville Centre, NY 11570</p>
                      </div> 
                    </th>
                    <th className="home-box">  
                      <div>
                        <img src={HomeImg} alt="Home" />
                        <p>529 Clinton Avenue, Rockville Centre, NY 11570</p>
                      </div>   
                     </th>
                    <th className="home-box">
                      <div>
                        <img src={HomeImg} alt="Home" />
                        <p>529 Clinton Avenue, Rockville Centre, NY 11570</p>
                      </div>   
                    </th>
                    <th className="home-box"> 
                      <div>
                        <img src={HomeImg} alt="Home" />
                        <p>529 Clinton Avenue, Rockville Centre, NY 11570</p>
                      </div>   
                    </th>
                     <th className="home-box"> 
                      <div>
                        <img src={HomeImg} alt="Home" />
                        <p>529 Clinton Avenue, Rockville Centre, NY 11570</p>
                      </div>   
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>Status</td>
                    <td>Active</td>
                    <td>For Sale</td>
                    <td>For Sale</td>
                    <td>Active</td>
                     <td>Active</td>
                  </tr>
                  <tr>
                    <td>List price</td>
                    <td>$2,999,888</td>
                    <td>$4,750,000</td>
                    <td>$670,000</td>
                    <td>$659,000</td>
                    <td>$659,000</td>
                  </tr>
                  <tr>
                    <td>Price/sqft</td>
                    <td>$484</td>
                    <td>$760</td>
                    <td>$419</td>
                    <td>$330</td>
                    <td>$330</td>
                  </tr>
                  <tr>
                    <td>Bedrooms</td>
                    <td>6</td>
                    <td>4</td>
                    <td>3</td>
                    <td>4</td>
                    <td>4</td>
                  </tr>
                  <tr>
                    <td>Bathrooms</td>
                    <td>7</td>
                    <td>8</td>
                    <td>2</td>
                    <td>4</td>
                    <td>4</td>
                  </tr>
                  <tr>
                    <td>Square feet</td>
                    <td>6,200</td>
                    <td>6,250</td>
                    <td>1,600</td>
                    <td>2,000</td>
                    <td>2,000</td>
                  </tr>
                  <tr id="Interior" className="type-header">
                    <td>Interior</td>
                    <td colSpan={totalColumns - 1}></td>
                  </tr>
                  <tr>
                    <td>Home type</td>
                    <td>Single Family Residence</td>
                    <td>Single Family Residence</td>
                    <td>Single Family Residence, Residential</td>
                    <td>Single Family Residence</td>
                    <td>Single Family Residence</td>
                  </tr>
                  <tr>
                    <td>Property condition</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Cooling</td>
                    <td>Central Air</td>
                    <td>Central Air</td>
                    <td>Wall/Window Unit(s)</td>
                    <td>Central Air</td>
                     <td>Central Air</td>
                  </tr>
                  <tr>
                    <td>Heating</td>
                     <td></td>
                    <td>Hot Water, Natural Gas</td>
                    <td>Ducts</td>                     
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Year built</td>
                    <td>1989</td>
                    <td>1996</td>
                    <td>1987</td>
                    <td>1960</td>
                    <td>1960</td>
                  </tr>
                  <tr>
                    <td>Architectural style</td>
                    <td></td>
                    <td>Colonial</td>
                    <td>Contemporary</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>New construction</td>
                    <td></td>
                    <td>No</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Appliances</td>
                    <td>Dishwasher, Washer/Dryer</td>
                    <td>Dishwasher, Dryer, Freezer, Indoor Grill, Microwave, Range, Washer</td>
                    <td>Dishwasher, Dryer, Freezer, Gas Range, Microwave, Refrigerator, Washer</td>
                    <td>Washer/Dryer</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Full bathrooms</td>
                    <td>6</td>
                    <td>5</td>
                    <td>2</td>
                    <td>3</td>
                    <td>2</td>
                  </tr>
                  <tr>
                    <td>Main level bedrooms</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Bedroom level</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Dining room level</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Family room level</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Kitchen level</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Living room level</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Basement</td>
                    <td></td>
                    <td></td>
                    <td>Finished</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Major remodel year</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Flooring</td>
                    <td>Hardwood</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Hardwood</td>
                  </tr>
                  <tr>
                    <td>Window features</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Interior features</td>
                    <td></td>
                    <td>Fireplace, Walk-In Closet(s), Wet Bar, Bidet</td>
                    <td>Eat-in Kitchen, His and Hers Closets, Open Floorplan, Oven/Range-Gas, Over&lt;Counter, Smart Thermostat</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Number of fireplaces</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Fireplace features</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Security features</td>
                    <td></td>
                    <td>Security System</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr id="Property" className="type-header">
                     <td>Property</td>
                    <td colSpan={totalColumns - 1}></td>
                  </tr>
                  <tr>
                    <td>Lot size</td>
                    <td></td>
                    <td>0.54 Acres</td>
                    <td>0.04 Acres</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Lot features</td>
                    <td></td>
                    <td>Back</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Exterior features</td>
                    <td>Balcony, Garden</td>
                    <td>Outdoor Grill, Sprinkler System</td>
                    <td></td>
                    <td>Courtyard, Balcony, Garden, Terrace</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Heating</td>
                    <td></td>
                    <td>Hot Water, Natural Gas</td>
                    <td>Ducts</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Patio and porch details</td>
                    <td>Other</td>
                    <td>Patio</td>
                    <td></td>
                    <td>Other, Terrace</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Total parking spaces</td>
                    <td></td>
                    <td>3</td>
                    <td>0</td>
                    <td>0</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Parking features</td>
                    <td></td>
                    <td>Off Street</td>
                    <td>Driveway</td>
                    <td>Garage</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Attached garage</td>
                    <td></td>
                    <td>Yes</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Garage spaces</td>
                    <td></td>
                    <td>3</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Fencing</td>
                    <td></td>
                    <td>R1-1</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Zoning</td>
                    <td></td>
                    <td>3</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Total structure area</td>
                    <td>6,200</td>
                    <td>6,250</td>
                    <td>1,600</td>
                    <td>2,000</td>
                    <td>1,296</td>
                  </tr>
                  <tr>
                    <td>View description</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Garden</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Topography of land</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Residential vegetation</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Construction materials</td>
                    <td></td>
                    <td>Stone, Stucco</td>
                    <td>Brick</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Foundation</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Roof</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Road surface type</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Special conditions</td>
                    <td>Resale</td>
                    <td></td>
                    <td>None</td>
                    <td>Resale</td>
                    <td>Resale</td>
                  </tr>
                  <tr>
                    <td>Parcel number</td>
                    <td>044390007</td>
                    <td>008710095</td>
                    <td>026610119</td>
                    <td>082340030</td>
                    <td>079750040</td>
                  </tr>
                  <tr>
                    <td>Sewer information</td>
                    <td></td>
                    <td>Septic Tank</td>
                    <td>Public Sewer</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Water information</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Utilities for property</td>
                    <td></td>
                    <td></td>
                    <td>Electricity Connected, Natural Gas Connected</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr id="HOAFinancial" className="type-header">
                    <td>HOA Financial</td>
                    <td colSpan={totalColumns - 1}></td>
                  </tr>
                  <tr>
                    <td>Annual tax amount</td>
                    <td>$22,992</td>
                    <td>$26,394</td>
                    <td>$3,598</td>
                    <td>$6,444</td>
                    <td>$5,556</td>
                  </tr>
                  <tr>
                    <td>HOA</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Tax assessed value</td>
                    <td>$2,670,000</td>
                    <td>$2,569,000</td>
                    <td>$594,000</td>
                    <td>$761,000</td>
                    <td>$612,000</td>
                  </tr>
                  <tr>
                    <td>Listing terms</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Offer review date</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Rent Zestimate</td>
                    <td>$7,355/mo</td>
                    <td>$5,128/mo</td>
                    <td></td>
                    <td>$4,697/mo</td>
                    <td>$3,680/mo</td>
                  </tr>
                  <tr id="Neighbourhood" className="type-header">
                     <td>Community and neighborhood</td>
                      <td colSpan={totalColumns - 1}></td>  
                  </tr>
                   <tr>
                    <td>Region</td>
                    <td>Malba</td>
                    <td>Staten Island</td>
                    <td>Bronx</td>
                    <td>Brooklyn</td>
                    <td>Brooklyn</td>
                  </tr>
                  <tr>
                    <td>Commute time</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Walk Score®</td>
                    <td>19</td>
                    <td>65</td>
                    <td>$594,000</td>
                    <td>66</td>
                    <td>77</td>
                  </tr>
                  <tr>
                    <td>Transit Score™</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>GreatSchools rating</td>
                    <td>Primary: 8</td>
                    <td>Primary: 3</td>
                    <td>Primary: 5</td>
                    <td>Primary: 6</td>
                    <td>Primary: 7</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>Middle: 6</td>
                    <td>Middle: 7</td>
                    <td>Middle: 6</td>
                    <td>Middle: 6</td>
                    <td>Middle: 6</td>
                  </tr>
                  <tr>
                    <td>GreatSchools rating</td>
                    <td>High: 4</td>
                    <td>High: 5</td>
                    <td></td>
                    <td>High: 3</td>
                    <td>High: 5</td>
                  </tr>
                  <tr>
                    <td>Subdivision</td>
                    <td>Malba</td>
                    <td></td>
                    <td></td>
                    <td>Canarsie</td>
                    <td>East Flatbush</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Container>
        </section>
        <Footer />
      </div>
    </>
  );
}
export default CompareHomes;
